import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import style from '../Debug.module.scss';

const LiveStreamPanel = (props = {}) => {
  const {
    handleSetCdnMapping,
    handleSetVideoOrigin,
    handleToggleLiveStream,
    playerConfig,
    selectedCdnMapping,
    selectedTimeout,
    selectedVideoOrigin,
  } = props;
  const debugCdnMapping = _.get(playerConfig, 'debug_cdn_mapping');
  const debugVideoStackMapping = _.get(playerConfig, 'debug_videostack_mapping');
  const generateOptions = ({ list, selected }) =>
    _.map(list, (key, value) => (
      <option value={key} selected={selected === key}>
        {value}
      </option>
    ));

  return (
    <div className={style.panel}>
      <ul className={style.livestreamContainer}>
        <li>
          <div className={style.header}>Live Stream</div>
          <div className={style.body}>
            <div className={style.formLabel}>Disable Livestream Timeout?</div>
            <div>
              <select onChange={handleToggleLiveStream}>
                <option />
                <option value="YES" selected={selectedTimeout === 'YES'}>
                  YES
                </option>
                <option value="NO" selected={selectedTimeout === 'NO'}>
                  NO
                </option>
              </select>
            </div>
          </div>
        </li>
        <li>
          <div className={style.header}>Video CDN</div>
          <div className={style.body}>
            <div className={style.formLabel}>CDN parameter: {selectedCdnMapping}</div>
            <div>
              <select onChange={handleSetCdnMapping}>
                <option value={null} selected={!selectedCdnMapping} />
                {generateOptions({ list: debugCdnMapping, selected: selectedCdnMapping })}
              </select>
            </div>
          </div>
        </li>
        <li>
          <div className={style.header}>Video Origin</div>
          <div className={style.body}>
            <div className={style.formLabel}>assetTypes parameter: {selectedVideoOrigin}</div>
            <div>
              <select onChange={handleSetVideoOrigin}>
                <option value={null} selected={!selectedVideoOrigin} />
                {generateOptions({ list: debugVideoStackMapping, selected: selectedVideoOrigin })}
              </select>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

LiveStreamPanel.defaultProps = {
  playerConfig: null,
  selectedCdnMapping: null,
  selectedTimeout: 'NO',
  selectedVideoOrigin: null,
};

LiveStreamPanel.propTypes = {
  handleSetCdnMapping: PropTypes.func.isRequired,
  handleSetVideoOrigin: PropTypes.func.isRequired,
  handleToggleLiveStream: PropTypes.func.isRequired,
  playerConfig: PropTypes.shape({}),
  selectedCdnMapping: PropTypes.string,
  selectedTimeout: PropTypes.string,
  selectedVideoOrigin: PropTypes.string,
};

export default LiveStreamPanel;
